// src/config.js

//----------------------------------------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------------------------------------------------------------------------------------------------------------//
// FOR TEST:
//----------------------------------------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------------------------------------------------------------------------------------------------------------//

// NODE

//export const NODE_BACKEND_API_URL = "http://localhost:8096/apitest";
//export const NODE_BACKEND_SCH_URL = "http://localhost:8096/api/v3/search";
//export const NODE_BACKEND_PRD_URL = "http://localhost:8096/api/v3/";
//export const NODE_BACKEND_LOG_URL = "http://localhost:8096/apitest/api/login";

// FLASK

//export const NODE_FLASK_LOG_URL = "http://localhost:5000/auth/login";
//export const FLASK_BACKEND_API_URL = "http://localhost:5000/api/fileupload/";
//export const FLASK_CLIPBOARD_API_URL = "http://localhost:5000/generate-clipboard-data";


//----------------------------------------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------------------------------------------------------------------------------------------------------------//
// FOR PRODUCTION URLs:
//----------------------------------------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------------------------------------------------------------------------------------------------------------//
// VPS
// NODE

export const NODE_BACKEND_API_URL = "https://horizontepyme.proyectoshorizontales.com/apitest"; // <-- PRODUCTS.ROUTES
export const NODE_BACKEND_SCH_URL = "https://horizontepyme.proyectoshorizontales.com/api/v3/search"; // <-- PRODUCTSEARCH
export const NODE_BACKEND_PRD_URL = "https://horizontepyme.proyectoshorizontales.com/api/v3/";
export const NODE_BACKEND_LOG_URL = "https://horizontepyme.proyectoshorizontales.com/apitest/api/login";
export const NODE_INVOICE_API_URL = "https://horizontepyme.proyectoshorizontales.com/apitest"; // <-- INVOICE SYSTEM (base URL)
export const NODE_SUPPLIERS_API_URL = "https://horizontepyme.proyectoshorizontales.com/apitest"; // <-- SUPPLIERS MODULE

// FLASK

export const NODE_FLASK_LOG_URL = "https://horizontepyme.proyectoshorizontales.com/flaskapi/auth/login";
export const FLASK_BACKEND_API_URL = "https://horizontepyme.proyectoshorizontales.com/flaskapi/fileupload/"; // <-- FLASK FILEUPLOAD
export const FLASK_CLIPBOARD_API_URL = "https://horizontepyme.proyectoshorizontales.com/flaskapi/generate-clipboard-data"; // <-- FLASK CLIPBOARD GENERATION



// CIA SERVER (direct IP, no nginx proxy, for testing on LAN)
/*
// NODE — relative paths (works from any LAN client since frontend is served by the same Node process)
export const NODE_BACKEND_API_URL = "http://192.168.0.4:8096/apitest";
export const NODE_BACKEND_SCH_URL = "http://192.168.0.4:8096/api/v3/search";
export const NODE_BACKEND_PRD_URL = "http://192.168.0.4:8096/api/v3/";
export const NODE_BACKEND_LOG_URL = "http://192.168.0.4:8096/apitest/api/login";
export const NODE_INVOICE_API_URL = "http://192.168.0.4:8096/apitest";
export const NODE_SUPPLIERS_API_URL = "http://192.168.0.4:8096/apitest";

// FLASK — direct port, no nginx prefix
export const NODE_FLASK_LOG_URL = "http://192.168.0.4:5001/auth/login";
export const FLASK_BACKEND_API_URL = "http://192.168.0.4:5001/api/fileupload/";
export const FLASK_CLIPBOARD_API_URL = "http://192.168.0.4:5001/generate-clipboard-data";
*/

//----------------------------------------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------------------------------------------------------------------------------------------------------------//
// SUPPLIERS MODULE CONFIGURATION
//----------------------------------------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------------------------------------------------------------------------------------------------------------//

/**
 * Suppliers Development Mode
 * 
 * When true: Uses mock data for brands and categories (no backend required)
 * When false: Connects to production endpoints (/getallbrands, /getcategorynames)
 * 
 * Use Cases:
 * - Set to true for frontend development and testing without backend
 * - Set to false for production or when backend endpoints are ready
 */
export const SUPPLIERS_DEV_MODE = false;

//----------------------------------------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------------------------------------------------------------------------------------------------------------//
// INVOICE SYSTEM FEATURE FLAGS
//----------------------------------------------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------------------------------------------------------------------------------------------------------------//

/**
 * Invoice Type Feature Flags
 * 
 * Control which invoice types are available in the system.
 * Set to true to enable, false to disable.
 * 
 * Use Cases:
 * - Start with Presupuesto only while testing CUIT integration
 * - Gradually enable Factura C, then B, then A as features are completed
 * - Disable specific types temporarily for maintenance or compliance
 */
export const INVOICE_FEATURES = {
    // Factura A - Responsable Inscripto
    // Requires: CUIT search, client validation, AFIP registration
    FACTURA_A_ENABLED: true,
    
    // Factura B - Monotributo / Exento
    // Requires: CUIT search, client validation, AFIP registration
    FACTURA_B_ENABLED: true,
    
    // Enable CUIT search for Factura B
    // When true: Factura B will show optional CUIT search field (only required over $10M)
    // When false: Factura B requires client data always
    FACTURA_B_ALLOW_CLIENT_SEARCH: true,
    
    // Factura C - Consumidor Final
    // Requires: AFIP registration (no client data needed)
    FACTURA_C_ENABLED: false,
    
    // Presupuesto (Budget/Quote) - No AFIP registration
    // Optional: Can include CUIT search for record keeping
    PRESUPUESTO_ENABLED: true,
    
    // Enable CUIT search for Presupuesto
    // When true: Presupuesto will show optional CUIT search field
    // When false: Presupuesto has no client fields (simple quote)
    PRESUPUESTO_ALLOW_CLIENT_SEARCH: true,
    
    // Enable "Copy Data" functionality for Presupuesto
    // When true: Adds clipboard copy to confirmation button
    // Copies formatted cart data for pasting into other software
    // When false: Only generates presupuesto (standard behavior)
    PRESUPUESTO_COPY_TO_CLIPBOARD: true,
    
    // Register Presupuesto with AFIP via TusFacturas
    // When true: Presupuesto generates CAE and is registered with AFIP (like Factura C)
    // When false: Presupuesto is saved locally only, NO AFIP registration, NO CAE
    // IMPORTANT: Set to false if you want true "quotes" that don't consume AFIP numbering
    PRESUPUESTO_REGISTER_WITH_AFIP: false
};

// --- Other potential configuration variables can go here ---
// export const SOME_OTHER_SETTING = "value";